import React, { useContext } from "react";
import { ContactFormContext } from "../context/contactFormContext";
import * as Animate from "react-reveal";

export default function Contact() {
  const { handleOpenContact } = useContext(ContactFormContext);

  return (
    <section
      id="contact"
      className="bg-[#F5FFFB] contact-abstract-bg mb-12 lg:mb-16">
      <div className="m-auto">
        <div className="flex flex-col gap-y-4 py-16  md:py-20 lg:py-28 justify-center items-center md:gap-y-8">
          <Animate.Fade bottom>
            <div className="max-w-[551px] md:w-[80%]  flex flex-col gap-y-2 justify-center items-center md:gap-y-4">
              <p className="text-2xl md:text-3xl  lg:text-4xl xl:text-5xl text-center font-semibold">
                Got Any Question<span className="text-cstm-green">?</span>
              </p>
              <p className="text-center text-base md:text-lg mt-3 min-w-[300px] text-cstm-grey w-11/12 lg:w-10/12 ">
                We are always available to address any inquiries you may have.
                Kindly contact us if you have any questions.
              </p>
            </div>
            <button
              onClick={() => handleOpenContact(true)}
              className="flex justify-center text-[#fff] bg-cstm-green text-sm lg:text-base font-medium px-8 py-4 md:px-6 md:py-4 rounded-lg transition-all ease-in-out hover:shadow-lg mt-7">
              Contact us
              <span className="pl-3 pt-1">
                <svg
                  width="15"
                  height="14"
                  viewBox="0 0 15 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M1 7H13.5M13.5 7L7.5 1M13.5 7L7.5 13"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </button>
          </Animate.Fade>
        </div>
      </div>
    </section>
  );
}
